<template>
  <nav class="navbar">
    <div class="container d-flex justify-content-between align-items-center">
      <!-- Logo -->
      <div class="logo">
        <img :src="logoImage" alt="Nolido" class="logo-img">
      </div>

      <!-- Navigation Menu (Desktop) -->
      <ul class="nav-menu">
        <li class="nav-item">
          <router-link to="/" class="nav-link">Accueil</router-link>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link" @click.prevent="openModal('fonctionnement')">Fonctionnement</a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link" @click.prevent="openModal('avantages')">Avantages</a>
        </li>
      </ul>

      <!-- Right Section (Desktop) -->
      <div class="nav-actions">
        <CustomButton
          label="Demander une cotation" 
          @click="handleDownload"
        />
        <div class="language-badge">
          <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3E%3Crect fill='%23ED2939' width='900' height='600'/%3E%3Crect fill='%23fff' width='600' height='600'/%3E%3Crect fill='%23002395' width='300' height='600'/%3E%3C/svg%3E" alt="FR" class="flag-icon-badge">
          <span class="language-text">FR</span>
        </div>
      </div>  

      <!-- Hamburger Menu Button (Mobile) -->
      <button class="hamburger-menu" @click="toggleMobileMenu" :class="{ active: mobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Menu Dropdown -->
    <div class="mobile-menu" :class="{ show: mobileMenuOpen }">
      <ul class="mobile-nav-list">
        <li><router-link to="/" class="mobile-nav-link" @click="closeMobileMenu">Accueil</router-link></li>
        <li><a href="#" class="mobile-nav-link" @click.prevent="openModal('fonctionnement'); closeMobileMenu()">Fonctionnement</a></li>
        <li><a href="#" class="mobile-nav-link" @click.prevent="openModal('avantages'); closeMobileMenu()">Avantages</a></li>
        <li class="mobile-cta">
          <CustomButton label="Demander une cotation" @click="handleDownload" />
        </li>
      </ul>
    </div>

    <!-- Modal -->
    <div class="modal-overlay" :class="{ show: activeModal }" @click="closeModal">
      <div class="modal-content" @click.stop>
        <!-- Modal Header -->
        <div class="modal-header">
          <button class="modal-close" @click="closeModal">&times;</button>
        </div>

        <!-- Modal Body - Component Display -->
        <div class="modal-body">
          <component :is="modalComponent" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'
import Fonctionnement from '@/components/Fonctionnement.vue'
import AvantagesSection from '@/components/AvantagesSection.vue'

export default {
  name: 'NavbarNolido',
  components: {
    CustomButton,
    Fonctionnement,
    AvantagesSection
  },
  data() {
    return {
      logoImage: require('@/assets/img/logo.png'),
      mobileMenuOpen: false,
      activeModal: null,
      modalComponent: null,
      modalsData: {
        fonctionnement: {
          component: 'Fonctionnement'
        },
        avantages: {
          component: 'AvantagesSection'
        }
      }
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
    },
    openModal(modalType) {
      const modalData = this.modalsData[modalType]
      if (modalData) {
        this.modalComponent = modalData.component
        this.activeModal = modalType
      }
    },
    closeModal() {
      this.activeModal = null
      this.modalComponent = null
    },
    handleDownload() {
      this.$router.push('/devis')
      this.closeMobileMenu()
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.navbar {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  padding: 0.75rem 2rem;
}

.navbar .container {
  padding-left: 0;
  padding-right: 0;
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  cursor: pointer;
}

.logo-img {
  width: 120px;
  object-fit: contain;
}

/* Navigation Menu */
.nav-menu {
  display: flex !important;
  flex-direction: row !important;
  list-style: none;
  gap: 1.5rem;
  flex: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
}

.nav-link {
  color: #1a1a1a !important;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 0.5rem 0;
  transition: color 0.3s ease;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.nav-link:hover {
  color: #F5A623 !important;
}

/* Right Actions */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.btn-language {
  background: white;
  border: 2px solid #e5e5e5;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  transition: all 0.3s ease;
}

.btn-language:hover {
  border-color: #F5A623;
  transform: scale(1.05);
}

.flag-icon {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
}

.language-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: default;
}

.flag-icon-badge {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
}

.language-text {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 0.5px;
}

/* Responsive */
@media (max-width: 992px) {
  .navbar {
    padding: 0.75rem 1.5rem;
  }
  
  .navbar .container {
    gap: 1rem;
  }
  
  .nav-menu {
    gap: 1rem;
  }
  
  .logo-img {
    width: 100px;
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 0.75rem 1rem;
  }
  
  .nav-menu,
  .nav-actions {
    display: none !important;
  }
  
  .hamburger-menu {
    display: flex;
  }
  
  .mobile-menu {
    display: block;
  }
  
  .navbar .container {
    justify-content: space-between;
    gap: 1rem;
  }
  
  .logo-img {
    width: 90px;
  }
}

@media (max-width: 576px) {
  .navbar {
    padding: 0.6rem 0.75rem;
  }
  
  .logo-img {
    width: 80px;
  }
  
  .mobile-nav-link {
    padding: 0.9rem 1rem;
    font-size: 15px;
  }
  
  .mobile-cta {
    padding: 0.9rem 1rem;
  }
}
.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.hamburger-menu span {
  display: block;
  width: 100%;
  height: 3px;
  background-color: #1a1a1a;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger-menu.active span:nth-child(1) {
  transform: translateY(10.5px) rotate(45deg);
}

.hamburger-menu.active span:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.active span:nth-child(3) {
  transform: translateY(-10.5px) rotate(-45deg);
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  z-index: 999;
}

.mobile-menu.show {
  max-height: 600px;
  overflow-y: auto;
}

.mobile-nav-list {
  list-style: none;
  padding: 1rem 0;
  margin: 0;
}

.mobile-nav-list > li {
  border-bottom: 1px solid #f5f5f5;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  color: #1a1a1a;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.mobile-nav-link:hover {
  background: #FFF5E8;
  color: #F5A847;
}

.mobile-cta {
  padding: 1rem 1.5rem;
  border-top: 2px solid #f5f5f5;
}

@media (max-width: 768px) {
  .nav-menu,
  .nav-actions {
    display: none;
  }
  
  .hamburger-menu {
    display: flex;
  }
  
  .mobile-menu {
    display: block;
  }
  
  .navbar .container {
    justify-content: space-between;
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  opacity: 0;
  transition: opacity 0.3s ease;
  backdrop-filter: blur(4px);
}

.modal-overlay.show {
  display: flex;
  opacity: 1;
}

.modal-content {
  background: white;
  border-radius: 20px;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
  width: 92%;
  max-width: 900px;
  max-height: 85vh;
  overflow-y: auto;
  animation: slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.modal-content:hover {
  scrollbar-color: #F5A623 #f5f5f5;
}

/* scrollbar Firefox */
.modal-content {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.modal-content:hover {
  scrollbar-color: #F5A623 #f5f5f5;
}

/* scrollbar Chrome */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

.modal-content:hover::-webkit-scrollbar-thumb {
  background: #F5A623;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #1a1a1a;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.modal-close:hover {
  color: #F5A623;
}

.modal-body {
  padding: 0;
  color: #4a4a4a;
  font-size: 15px;
  line-height: 1.7;
  max-height: 70vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-width: 100%;
    max-height: 80vh;
  }
  
  .modal-hero {
    min-height: 50px;
    padding: 1.5rem 1.5rem 1rem 1.5rem;
  }
  
  .modal-title {
    font-size: 20px;
  }
}
</style>